import { EntityBase, Var } from "addeus-common-library/stores/firestore";
import { Collection } from "addeus-common-library/stores/firestore/collection";
import { Entity } from "addeus-common-library/stores/firestore/entity";
import moment from "moment-with-locales-es6";

enum ReviewNetwork {
    google = "google",
}

export class ReviewAnswer extends EntityBase {
    @Var(String)
    uid?: string;

    @Var(String)
    answer = "";

    @Var(String)
    draftAnswer?: string;

    @Var(moment)
    createdAt: moment = moment();

    @Var(moment)
    sentAt: moment | null = null;

    get isDraft() {
        return !this.isSent;
    }

    get isSent() {
        return (
            this.sentAt !== null &&
            this.sentAt !== undefined &&
            (this.sentAt.isValid() as boolean)
        );
    }
}

@Collection({
    namespace: "Review",
})
export class Review extends Entity {
    @Var(ReviewNetwork)
    from: ReviewNetwork = ReviewNetwork.google;

    @Var(String)
    name = "";

    @Var(String)
    profilePicture?: string;

    @Var(String)
    comment?: string;

    @Var(Array.of(String))
    medias: string[] = [];

    @Var(moment)
    createdAt: moment = moment();

    @Var(Number)
    rating: number = 0;

    @Var(Number)
    likes: number = 0;

    @Var(Array.of(ReviewAnswer))
    answers: ReviewAnswer[] = [];

    @Var(Boolean)
    viewed: boolean = false;
}
